import { WidgetJsonSchema } from "../schema/widget-json-schema.model";
import { ItemMetadataBase } from "./item-metadata.model";


export class LengthItemMetadataBase extends ItemMetadataBase {

    maxLength: number = 40

    constructor(type: string) {
        super(type)
    }

    override schema(): WidgetJsonSchema {
        let schema = super.schema()
        schema["maxLength"] = this.maxLength
        return schema
    }

}

export interface LengthItemMetadata extends LengthItemMetadataBase { }